var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.persons < 4)?_vm._l((_vm.persons),function(i){return _c('img',{key:i,staticClass:"mr-1",attrs:{"src":require("../../assets/icons/person.svg"),"alt":"person"}})}):[_c('img',{staticClass:"mr-1",attrs:{"src":require("../../assets/icons/person.svg"),"alt":"person"}}),_vm._v(" x "+_vm._s(_vm.persons)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }